// extracted by css-extract-rspack-plugin
export default {"root":"root-wear9P","placeholder":"placeholder-Zj5WKg"};